<template>
          <section class="bottomDiv flex-column pt-0" :class="[readOnly ? 'interview-details-main-container': 'interview-report-main-container']">
            <v-tabs v-model="activeTab" class="tab-height" v-if="showTabs">
             <v-tab v-for="(tab, index) in tabsData.headers" :key="index" @change="selectSkill(tab.name)">
          {{ tab.name }} <span v-if="!readOnly">&nbsp; {{ tab.ScoredFeedbackCount }}/{{ tab.totalfeedBackcount }}</span>
            </v-tab>
      </v-tabs>

        
        <div class="report-scroll-shell" :style="scrollColumnCssVars" ref="reportScrollShell">
          <v-btn icon class="report-arrow report-arrow--left elevation-3" v-if="showColumnArrows" :disabled="!canScrollLeft" :style="{ top: arrowTop + 'px' }" @click="scrollColumns(-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn icon class="report-arrow report-arrow--right elevation-3" v-if="showColumnArrows" :disabled="!canScrollRight" :style="{ top: arrowTop + 'px' }" @click="scrollColumns(1)">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
          <div class="report-content">
        <div class="larger-bottom" :class="{ 'read-larger-bottom': readOnly, 'write-larger-bottom': !readOnly }">
            <div class="central-table">
                <div class="main-table rounded-xl">           
                        <div class="data-grid interview-report-data-grid">
                                <div :class="[!readOnly ? 'scroll-this': '']">
                                    <div class="interview-panels d-flex" v-if="showInterviewerColumns">
                        <div class="assessment-instructions report-row-label py-2">
                            <span class="text-body-2 font-weight-bold">Parameters</span>
                        </div>
                        <div class="columns-scroll d-flex" @scroll="syncColumnScroll">
                            <div
                                v-for="column in interviewerColumns"
                                :key="column.index"
                                class="interviewer-header-cell report-col-cell"
                                :class="column.bgClass"
                            >
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span class="interviewer-email-label py-2" v-bind="attrs" v-on="on">
                                            {{ columnLabel(column.feedback) }}
                                        </span>
                                    </template>
                                    <span>{{ columnLabel(column.feedback) }}</span>
                                </v-tooltip>
                            </div>
                        </div>
                    </div>
                                    <v-container fluid class="pa-0">
                                        <div class="mx-h-81">
                                            <div class="d-flex" v-if="activeTab == 0 && showTabs">
                                                <v-card
                                                :class="readOnly ? 'assessment-instructions report-row-label mb-4' : 'mb-6 w-100 rounded-xl elevation-0  px-3 py-3 mb-0'">
                                                <div v-if="activeTab == 0" class="button-toggle-row">
                                         <div v-if="showTabs">
                                        <v-btn-toggle class="d-flex" :class="{'justify-start':readOnly, 'justify-end': !readOnly}"
                                        v-if="tabsData.data[0].length > 1   "
                                        v-model="toggleType"
                                        mandatory
                                        dense
                                        rounded
                                    >
                                        <v-btn
                                        v-for="(skillBtn, index) in tabsData.data[0]"
                                        class="w-100 skill-btn"
                                        :class="
                                        toggleType == index
                                            ? 'blue white--text caption'
                                            : 'gray-02 caption'
                                        " :key="skillBtn.subName"
                                        :style="{ width: maxBtnWidth + 'px' }"
                                        >
                                        {{ skillBtn.subName }}
                                        </v-btn>
                                    </v-btn-toggle>
                                    <div class="d-flex" :class="{'justify-start': readOnly, 'justify-end': !readOnly}">
                                        <v-btn
                                            elevation="2"
                                            outlined
                                            rounded
                                            class="btn outline-btn pa-4" v-if="tabsData.data[0].length == 1" >
                                            {{tabsData.data[0][0].subName }}
                                        </v-btn>
                                        <div :class="[colColors[2]]"></div>
                                    </div>
                                </div>                            
                            </div>
                                                </v-card>

                                            <div v-if="readOnly" class="columns-scroll d-flex" @scroll="syncColumnScroll">
                                                <div
                                                    v-for="column in interviewerColumns"
                                                    :key="column.index"
                                                    class="feedback-title interview-ratings report-col-cell"
                                                    :class="column.bgClass"
                                                ></div>
                                            </div>
                                            </div>
                                          
                                           
                                        </div>
                                        <div v-for="(data, index) in displayData" class="mx-h-81" :key="data.title || data.name || index" :class="{ 'first-row': index === 0 && selectedSkill !== 'Core Skills' }" id="score-scale" >
                                            <div class="d-flex">
                                                <v-card v-if="ratingScale == 10"
                                                :class="readOnly ? 'assessment-instructions report-row-label mb-4' : 'mb-6 w-100 rounded-xl elevation-0 cardBorder px-3 py-3 mb-0'">
                                                    <p  class="feedback-title pl-0">{{data?.title || data?.name }}</p>
                                                    <p class="feedback-desc pl-0 mb-4">{{data.description}}</p>
                                                    <div class="d-flex" v-if="!readOnly">
                                                        <div
                                                            v-for="rate in ratingScale"
                                                            :key="rate"
                                                            @click="selectRatingValueForSkills(rate, index)"
                                                            :class="selectRating(rate, data.rating)"
                                                        >
                                                            {{ rate }}
                                                        </div>
                                                    </div>
                                                </v-card> 
                                                <v-card  v-if="ratingScale == 5"
                                                :class="readOnly ? 'assessment-instructions report-row-label mb-4' : 'mb-6 w-100 rounded-xl elevation-0 cardBorder px-3 py-3 mb-0'">
                                                    <v-row>
                                                        <v-col :cols="isMobile ? 12 : 8">
                                                    <p  class="feedback-title pl-0">{{data?.title || data?.name }}  </p>
                                                    <p class="feedback-desc pl-0 mb-4">{{data.description}}</p>
                                                        </v-col>
                                                        <v-col :cols="isMobile ? 12 : 4">
                                                             <div class="d-flex" :class="isMobile && 'justify-end'" v-if="!readOnly">
                                                        <div
                                                            v-for="rate in ratingScale"
                                                            :key="rate"
                                                            @click="selectRatingValueForSkills(rate, index)"
                                                            :class="selectRating(rate, data.rating)"
                                                        >
                                                            {{ rate }}
                                                        </div>
                                                    </div>
                                                    <div v-else-if="!showInterviewerColumns" class="d-flex align-center h-100" :class="isMobile ? 'justify-start' : 'justify-end'">
                                                        <span class="feedback-title">{{ formatRatingDisplay(data.rating) }} / {{ ratingScale }}</span>
                                                    </div>
                                                        </v-col>
                                                    </v-row>
                                                </v-card>
                                                <div v-if="showInterviewerColumns" class="columns-scroll d-flex" @scroll="syncColumnScroll">
                                                    <div
                                                        v-for="column in interviewerColumns"
                                                        :key="column.index"
                                                        class="feedback-title interview-ratings report-col-cell"
                                                        :class="column.bgClass"
                                                    >
                                                        {{ formatRatingDisplay(columnRating(data, column.index)) }} / 10
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="!readOnly && activeTab == inPersonDemoIndex">
                                            <p role-type="body-3" class="mb-3">Comments</p>
                                            <ckeditor @input="captureCommentInput"  :config="editorConfig" class="m-ckeditor" v-model="comment" @ready="onEditorReady">
                                            </ckeditor>
                                        </div>
                                    </v-container>
                                </div>
                        </div>
                </div>
            </div>
        </div>
             <div class="comment-section" v-if="showInterviewerColumns">
                <v-container fluid class="pa-0">
                    <div class="d-flex">
                        <div class="average-text report-row-label d-flex justify-end align-center font-weight-bold pr-4">
                            <span>Average</span>
                        </div>
                        <div class="columns-scroll d-flex" @scroll="syncColumnScroll">
                            <div
                                v-for="column in interviewerColumns"
                                :key="column.index"
                                class="feedback-title interview-average-ratings average-text report-col-cell"
                                :class="column.bgClass"
                            >
                                {{ columnAverage(column.index) | tofixRating }}
                            </div>
                        </div>
                    </div>
                </v-container>
                <v-container fluid class="pa-0">
                    <div class="d-flex comment-container">
                        <div class="report-row-label d-flex justify-end align-center pr-4">
                            <p class="average-text font-weight-bold mb-0">Comments</p>
                        </div>
                        <div class="columns-scroll d-flex" @scroll="syncColumnScroll">
                            <div
                                v-for="column in interviewerColumns"
                                :key="column.index"
                                class="report-col-cell d-flex"
                                :class="column.bgClass"
                                @click="showFullRemark(column.feedback)"
                            >
                                <div class="text-left interviewer-comments pa-2 rounded-lg cursor">
                                    <p class="text-left col-text-truncate mb-1" :class="column.textClass">{{ stripHtmlTags(column.feedback?.recommendation) }}</p>
                                    <p ref="remarkText" class="interview-remark col-text-truncate mb-0">{{ stripHtmlTags(column.feedback?.remark) }}</p>
                                    <span v-if="remarkOverflowFlags[column.index]" class="view-more-link">View more...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-container>   
                <comment-box :dialogActive="dialogActive" :dialogContent="dialogContent"  @dialogHandler="dialogHandler"></comment-box>
           </div>
          </div>
        </div>
</section>

</template>
<script>
import InterviewCommentComponent from './InterviewCommentComponent.vue';

// How many interviewer columns the left/right arrows advance per click.
const SCROLL_STEP_COLUMNS = 2;
// Minimum width (px) of each interviewer column; they grow to fill when few, scroll when many.
const INTERVIEWER_COLUMN_WIDTH = 132;

// Recommendation values grouped by the colour each maps to.
const REJECTED_RECOMMENDATIONS = ['Not Recommended', 'Below Standard'];
const ON_HOLD_RECOMMENDATIONS = ['On Hold', 'Moderately Recommended'];
const RECOMMENDED_RECOMMENDATIONS = ['Highly Recommended', 'Strongly Recommended', 'Recommended'];

export default{

    name: 'InterviewScoreCard',
    components: {'comment-box': InterviewCommentComponent },
    props: {
        readOnly: {
            type: Boolean,
            default: false
        },
        interViewFeedbackData: {
            type: Array,
            required: false 
        },
        tabsData: {
            type: Object,
            required: true 
        },
        disableNext: {
            type: Boolean,
            default: false
        },
        showTabs:{
            type: Boolean,
            default: true
        },
        ratingScale:{
            type: Number,
            default: 10
        },
        isInProgress:{
            type: Boolean,
            default: false
        }
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown;
        },
        singleInterviewerStyle() {
            return this.localInterViewFeedbackData.length === 1
                ? { flex: '0 0 50%', maxWidth: '50%' }
                : {};
        },
        singleInterviewerLabelStyle() {
            return this.localInterViewFeedbackData.length === 1
                ? { flex: '0 0 50%', maxWidth: '50%', minWidth: '50%' }
                : {};
        },
        // One descriptor per interviewer, in display order (left to right).
        // Drives every column: header, per-parameter scores, average and comments.
        interviewerColumns() {
            return this.localInterViewFeedbackData.map((feedback, index) => ({
                index,
                feedback,
                bgClass: this.colColors[index] || '',
                textClass: this.textColors[index] || '',
            }));
        },
        // Horizontal scrolling only kicks in once there is more than one interviewer.
        isMultiColumn() {
            return this.showInterviewerColumns && this.localInterViewFeedbackData.length > 1;
        },
        // Show the arrows only when the columns actually overflow the viewport.
        showColumnArrows() {
            return this.isMultiColumn && (this.canScrollLeft || this.canScrollRight);
        },
        // Expose the column-sizing constants to the stylesheet as CSS variables.
        scrollColumnCssVars() {
            return {
                '--interviewer-col-width': INTERVIEWER_COLUMN_WIDTH + 'px',
            };
        },
        showInterviewerColumns() {
            // Multi-interviewer column layout (header + scores + average + comments).
            // True for the legacy report (showTabs=true) and feedbackv2 (showTabs=false but tabsData is pre-built).
            return this.readOnly && Array.isArray(this.tabsData?.data) && this.tabsData.data.length > 0
        },
        displayData() {
            if (this.showTabs) {
                if (this.activeTab == 0) {
                    return this.tabsData.data[0][this.toggleType].data
                }
                return this.tabsData.data[this.activeTab].data
            }
            // showTabs=false but column layout active (feedbackv2): use the pre-built single group
            if (this.showInterviewerColumns) {
                return this.tabsData.data[0][0].data
            }
            return this.localInterViewFeedbackData
        },
        subjectAverageRatings() {

            if (this.activeTab == 0) {
                console.log('calledd ')
                return {name: this.coreSkillToggle[this.toggleType], avg: this.avgMap['coreSkill'+this.coreSkillToggle[this.toggleType]] };
            } else {
                console.log('calledd ')
                return {name:this.selectedSkill, avg: this.avgMap['skill'+this.selectedSkill]};
                }
        }, 
    },
    data(){
       return {
        maxBtnWidth: 100,
        remarkOverflowFlags: [],
        activeTab:0,
        avgMap: {},
        coreSkillToggle: [],
        coreSkilks: [],
        colColors: [],
        textColors: [],
        reportScrollLeft: 0,
        arrowTop: 0,
        canScrollLeft: false,
        canScrollRight: false,
        dialogActive: false,
        dialogContent: {},
        resultMap: {},
        selectedSkill: 'Core Skills',
        toggleType: 0,
        comment: "",
        editorConfig: {
            toolbar: [
            ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', 'Link', 
            'NumberedList', 'BulletedList', 'Undo', 'RemoveFormat']
            ],
            removeButtons: '',
            toolbarStartupExpanded: true,
            removePlugins: 'elementspath,resize'
        },
        tabs: [
        { title: "Home", content: "Welcome to the Home tab" },
        { title: "Profile", content: "Here's your profile information" },
        { title: "Settings", content: "Adjust your settings here" },
      ],
        skills: null,
        selectedSkillIndex: 0,
        countofRating: 0,
        inPersonDemoIndex:-1,
        localInterViewFeedbackData: [], 
       } 
  },
  watch: {
    interViewFeedbackData: {
        handler() {
            this.initializeLocalState()
            if (this.readOnly) {
                this.getColColors()
                this.$nextTick(this.refreshColumnLayout)
            }
        },
        deep: true
    },
  },
  mounted(){
    this.initializeLocalState()
    if(this.readOnly){
        if(this.showTabs && this.interViewFeedbackData[0]?.subjects){
            // legacy report: build result/avg maps from per-interviewer subjects/skills
            this.createtableData(this.interViewFeedbackData)
            this.createAvg(this.resultMap)
            this.coreSkillToggle = this.interViewFeedbackData[0].subjects.map(item => item.subjectName)
        } else if (this.showInterviewerColumns) {
            // feedbackv2 (or any case where tabsData is pre-built): wire up avgMap + toggle labels from tabsData
            this.coreSkillToggle = this.tabsData.data[0].map(item => item.subName)
        
            this.tabsData.data[0].forEach(group => {
                this.getAvgRating('coreSkill' + group.subName, group.data)
            })
        }

        this.getColColors()
        this.$nextTick(this.refreshColumnLayout)
        window.addEventListener('resize', this.refreshColumnLayout);
        window.addEventListener('scroll', this.updateArrowTop, true);
    }else{
        this.countofRating = this.countOfRatign()
        window.addEventListener('load', this.setScrollableHeight());
        window.addEventListener('resize', this.setScrollableHeight());
    }
    if(this.showTabs){
        this.getDemoIndex()
        this.calculateMaxWidth();  
   
    }
    
     this.formatReqData()
   
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.setScrollableHeight());
    window.removeEventListener('load', this.setScrollableHeight());
    window.removeEventListener('resize', this.refreshColumnLayout);
    window.removeEventListener('scroll', this.updateArrowTop, true);
  },
    filters: {
        strippedContent: function(string) {
            return string?.replace(/<\/?[^>]+>/ig, " "); 
            },
        tofixRating: function(number){
            return number % 1 !== 0 || !Number.isInteger(number) ? number.toFixed(1) : number
        }
    },
  methods:{
    cloneValue(value, fallback) {
      return JSON.parse(JSON.stringify(value ?? fallback))
    },
    initializeLocalState() {
      this.localInterViewFeedbackData = this.cloneValue(this.interViewFeedbackData, [])
     
    },
    showFullRemark(feedback) {
      if (this.stripHtmlTags(feedback?.remark)) {
        this.dialogContent = feedback
        this.dialogActive = true
      }
    },
    stripHtmlTags(string) {
      return string?.replace(/<\/?[^>]+>/ig, " ") || ''
    },
    updateRemarkOverflow() {
      this.$nextTick(() => {
        const refs = this.$refs.remarkText
        if (!refs) {
          this.remarkOverflowFlags = []
          return
        }
        const nodes = Array.isArray(refs) ? refs : [refs]
        this.remarkOverflowFlags = nodes.map((el) => el.scrollWidth > el.clientWidth + 1)
      })
    },
    formatRatingDisplay(rating) {
      if (rating === undefined || rating === null || rating === '') {
        return '--';
      }
      if(this.showTabs){
        return  Number(rating) < 10 ? `0${rating}` : rating;
      }else {
        return  Number(rating) < 5 ? `0${rating *2}` : rating * 2 ;
      }
      
    },
    calculateMaxWidth() {
      const maxLength = Math.max(
        ...this.tabsData.data[0].map((btn) => btn.subName.length)
      );

      this.maxBtnWidth = maxLength * 8 + 32;
    },

    setScrollableHeight() {
    const outer = document.querySelector('.interview-report-main-container');
    const header = document.querySelector('.tab-height');
    const scrollable = document.querySelector('.scroll-this');
    
    const remainingHeight = outer.offsetHeight - header.offsetHeight -80;
    //  scrollable.style.height = `${remainingHeight}px`;
    },
    getDemoIndex(){
        let demoIndexCB = ({name})=> name == 'Inperson Demo';
        this.inPersonDemoIndex = this.tabsData?.headers.findIndex(demoIndexCB)
    },
    captureCommentInput(content) {
        this.$emit("onCommentChange", content.replace(/<p>/g, '').replace(/<\/p>/g, ''));        
    },
    getCoreSkillFeedbackCount(){
        return this.interViewFeedbackData[0].subjects.reduce((acc, curvl)=>{
            return acc+curvl.feedback.length
        }, 0)
    },
    selectRatingValueForSkills(val, index) {
        if(!this.showTabs){
            this.localInterViewFeedbackData[index]['rating'] = val
            this.calcualteAvgRating()
             this.$emit("onRatingChange",{avg:this.calcualteAvgRating(), feedback: this.formatReqData('autosave')})
            this.nextBtnDisableCheck()
        }else{
        if(this.activeTab == 0){
            this.tabsData.data[this.activeTab][this.toggleType].data[index].rating = val
           this.tabsData.headers[this.activeTab].ScoredFeedbackCount = this.countCoreSkillRatings(this.tabsData.data[this.activeTab])
        
        } else{
            this.tabsData.data[this.activeTab].data[index].rating = val;
            this.tabsData.headers[this.activeTab].ScoredFeedbackCount = this.countNonCoreSkillRating(this.tabsData.data[this.activeTab].data)

        }
         this.$emit("onRatingChange",{avg:this.calcualteAvgRating(), feedback: this.formatReqData('autosave')})
         this.nextBtnDisableCheck()
        }

      
    //   this.skills[this.selectedSkillIndex].feedback[index].rating = val;
    },
    gotoDemoComparision(){
        this.formatReqData()
    },
    formatReqData(src = ''){
        if(this.showTabs){
            let req = {subjects: [], skills:[]}
            this.tabsData.data.forEach((item, index) =>{
                if(index == 0){
                    item.forEach((coreSub)=>{
                        req.subjects.push({subjectName: coreSub.subName, feedback: coreSub.data})
                    })   
                }else{
                    req.skills.push({skillName: item.subName, feedback: item.data})
                }
            })
            if(src !== 'autosave'){
                this.$emit('onRequestReady', req)
            }
        
            return req
        }else{
            if(src !== 'autosave'){
                this.$emit('onRequestReady', this.localInterViewFeedbackData)
            }
            return this.localInterViewFeedbackData
        }
    
    },
    calcualteAvgRating(){
        if(this.showTabs){
            return this.sumOfRating() /this.countofRating
        } else {
           let totalRatingSum = this.localInterViewFeedbackData.filter(({isRequired})=>isRequired).length * this.ratingScale;

            let filledRatingSum = this.localInterViewFeedbackData.filter(({isRequired})=> isRequired).reduce((acc, curr) => {
                const rating = parseInt(curr.rating) || 0; 
                return acc + rating;
            }, 0);

            return (filledRatingSum / totalRatingSum) * 10;
        }
    },
    nextBtnDisableCheck(){
        if(!this.showTabs){
            const requiredItems = this.localInterViewFeedbackData.filter((item) => item?.isRequired !== false);
            if(requiredItems.length > 0 && requiredItems.every((item) => Number(item?.rating) > 0)){
                 this.gotoDemoComparision()   
            }
        }else{
            if(this.countofRating == this.ratingFilledCount()){
                this.gotoDemoComparision()
        } 
        }
        
    },
    ratingFilledCount() {
    return this.tabsData.data.reduce((total, subject, index) => {
        let subjectCount = 0;
        
        if (index === 0) {
            subjectCount = subject.reduce((subtotal, coreSubject) => {
                return subtotal + coreSubject.data.reduce((ratingTotal, feedbackObj) => {
                    return ratingTotal + ((feedbackObj.title.includes('*') && feedbackObj.rating > 0) ? 1 : 0);
                }, 0);
            }, 0);
        } else {
            subjectCount = subject.data.reduce((ratingTotal, feedbackObj) => {
                return ratingTotal + ((feedbackObj.title.includes('*') && feedbackObj.rating > 0) ? 1 : 0);
            }, 0);
        }
        
        return total + subjectCount;
    }, 0);
},
    countMandatoryfeedback(data){
        return data.reduce((acc, cur)=>{
            return acc + (cur.title.includes('*') ? 1 : 0)
        },0)
    },
    countOfRatign(){
        if(this.showTabs){
            return this.tabsData.data.reduce((total, subject, index)=>{
                let subjectCount = 0
                if(index == 0){
                subjectCount = subject.reduce((subtoal, coreSubject)=>{
                        return subtoal +  this.countMandatoryfeedback(coreSubject.data)
                },0)
                } else {
                    subjectCount = this.countMandatoryfeedback(subject.data)
                }
                return total + subjectCount
            }, 0)
        }else{
            return this.interViewFeedbackData.filter((item) => item?.isRequired !== false).length
        }
   
    },
    sumOfRating(){
        return this.tabsData.data.reduce((total, subject, index)=>{
            let subjectCount = 0
            if(index ==0){
                subject.forEach((coreSubject)=>{
                    subjectCount += coreSubject.data.reduce((count, item) => {
                    return  count + (item.title.includes('*') ? item.rating : 0)
                    }, 0);  
                })
       
         } else{
            subjectCount = subject.data.reduce((count, item)=>{
                return  count + (item.title.includes('*') ? item.rating : 0)
            }, 0)
         }
         return total + subjectCount
        }, 0)
    },
    countNonCoreSkillRating(data){
        return data.reduce((count, item) => {
            return item.rating > 0 ? count + 1 : count;
            }, 0);
    },
     countCoreSkillRatings(data){
        return data.reduce((total, subject) => {
            const subjectCount = subject.data.reduce((count, item) => {
            return item.rating > 0 ? count + 1 : count;
            }, 0);
            
            return total + subjectCount;
        }, 0);
    },
    createAvg(data) {
        for (let key in data) {
            this.getAvgRating(key, data[key])    
            }
    },
    createtableData(interveiwData) {
        interveiwData.forEach((item, index) => {
                item.subjects.forEach((coreSubject) => {
                if (index == 0) {
                    this.resultMap['coreSkill' + coreSubject.subjectName] = coreSubject.feedback;
                } else {
                    this.pluckRating('coreSkill'+coreSubject.subjectName, coreSubject.feedback, index)
                }
            })  

            item.skills.forEach((skill) => {
                if (index == 0 && skill.skillName !== 'Core Skills') {
                    this.resultMap['skill' + skill.skillName] = skill.feedback;
                } else if(skill.skillName !== 'Core Skills'){
                    this.pluckRating('skill' + skill.skillName, skill.feedback, index)
                }
            })
            
        })

    },
    dialogHandler(data = '') {
        this.dialogActive = !this.dialogActive;
        this.dialogContent = data
    },
    pluckRating(key, feedback, outerIndex) {
        feedback.forEach((item, index) => {
            this.resultMap[key][index]['rating'+outerIndex] = item.rating
        })
    },

        // Average score per interviewer column for one skill group.
        getAvgRating(key, rows) {
            const columnCount = this.localInterViewFeedbackData.length || 1;
            const sums = new Array(columnCount).fill(0);
            const counts = new Array(columnCount).fill(0);
            rows.forEach((row) => {
                for (let column = 0; column < columnCount; column++) {
                    const rating = this.columnRating(row, column);
                    if (this.isValidRating(rating)) {
                        sums[column] += rating;
                        counts[column] += 1;
                    }
                }
            });
            // Tab feedback is already out of 10; feedback v2 is out of 5, so double it.
            const outOfTenMultiplier = this.showTabs ? 1 : 2;
            this.avgMap[key] = {
                avgs: sums.map((sum, column) => (counts[column] ? (sum / counts[column]) * outOfTenMultiplier : 0)),
            };
    },
    // ---- Interviewer column helpers ----
    columnLabel(feedback) {
        return feedback?.name || feedback?.interviewerEmail || '---';
    },
    columnRating(row, column) {
        // Interviewer 0's rating lives on `rating`; the rest on `rating1`, `rating2`, ...
        return column === 0 ? row.rating : row['rating' + column];
    },
    columnAverage(column) {
        const averages = this.subjectAverageRatings.avg?.avgs;
        const average = averages ? averages[column] : 0;
        return Number.isFinite(average) ? average : 0;
    },
    isValidRating(rating) {
        return rating !== undefined && rating !== null && rating !== '' && !Number.isNaN(Number(rating));
    },
    // ---- Horizontal scrolling of interviewer columns ----
    // Every row's columns live in its own `.columns-scroll` pane; we keep them all in sync
    // so the labels stay put (50%) while only the columns scroll within their own half.
    columnScrollPanes() {
        return this.$el ? Array.from(this.$el.querySelectorAll('.columns-scroll')) : [];
    },
    scrollColumns(direction) {
        const panes = this.columnScrollPanes();
        if (!panes.length) return;
        const cell = panes[0].querySelector('.report-col-cell');
        const columnWidth = cell ? cell.offsetWidth : INTERVIEWER_COLUMN_WIDTH;
        const target = panes[0].scrollLeft + direction * SCROLL_STEP_COLUMNS * columnWidth;
        // Animate the first pane; the rest follow instantly through syncColumnScroll.
        panes[0].scrollTo({ left: target, behavior: 'smooth' });
    },
    syncColumnScroll(event) {
        const left = event.target.scrollLeft;
        this.columnScrollPanes().forEach((pane) => {
            if (pane !== event.target && pane.scrollLeft !== left) pane.scrollLeft = left;
        });
        this.updateScrollAffordance();
    },
    updateArrowTop() {
        const shell = this.$refs.reportScrollShell;
        if (!shell) return;

        const rect = shell.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        if (!rect.height || !viewportHeight) return;

        const visibleTop = Math.max(rect.top, 0);
        const visibleBottom = Math.min(rect.bottom, viewportHeight);
        const hasVisibleArea = visibleBottom > visibleTop;
        const midpoint = hasVisibleArea
            ? (visibleTop + visibleBottom) / 2
            : viewportHeight / 2;
        const shellTop = Math.min(Math.max(midpoint - rect.top, 0), rect.height);

        const nextArrowTop = Math.round(shellTop);
        if (this.arrowTop !== nextArrowTop) {
            this.arrowTop = nextArrowTop;
        }
    },
    updateScrollAffordance() {
        const pane = this.columnScrollPanes()[0];
        this.updateArrowTop();
        if (!pane) {
            this.canScrollLeft = false;
            this.canScrollRight = false;
            return;
        }
        const maxScrollLeft = pane.scrollWidth - pane.clientWidth;
        this.canScrollLeft = pane.scrollLeft > 0;
        this.canScrollRight = pane.scrollLeft < maxScrollLeft - 1;
    },
    refreshColumnLayout() {
        this.updateScrollAffordance();
        this.updateRemarkOverflow();
    },
    getColColors() {
        this.colColors = this.localInterViewFeedbackData.map((item) => this.recommendationBgClass(item?.recommendation));
        this.textColors = this.localInterViewFeedbackData.map((item) => this.recommendationTextClass(item?.recommendation));
    },
    recommendationBgClass(recommendation) {
        if (REJECTED_RECOMMENDATIONS.includes(recommendation)) return 'rejected-bg';
        if (ON_HOLD_RECOMMENDATIONS.includes(recommendation)) return 'hold-bg';
        if (RECOMMENDED_RECOMMENDATIONS.includes(recommendation)) return 'recommend-bg';
        return '';
    },
    recommendationTextClass(recommendation) {
        if (REJECTED_RECOMMENDATIONS.includes(recommendation)) return 'rejected-txt';
        if (ON_HOLD_RECOMMENDATIONS.includes(recommendation)) return 'hold-txt';
        if (RECOMMENDED_RECOMMENDATIONS.includes(recommendation)) return 'recommended-txt';
        return '';
    },
    selectSkill(skillName) {
      this.selectedSkill = skillName;
      const element = document.getElementById("score-scale");
      element.scrollIntoView({behavior: "smooth", block: 'end',});
    },
    selectRating(rating, ratingValue) {
    if (ratingValue < rating) return "interviewRate";

    const scale5Map = { 1: "1", 2: "5", 3: "6", 4: "8", 5: "9" };

    if (this.ratingScale === 5) {
        const index = scale5Map[rating];
        return index ? `interviewRate${index} white--text` : "interviewRate";
    }

    return rating >= 1 && rating <= 10
        ? `interviewRate${rating}${rating === 1 ? " white--text" : ""}`
        : "interviewRate";
    },
    onEditorReady(editor) {
      editor.on("afterCommandExec", function(event) {
        var commandName = event.data.name;
        if(['ckeditor_wiris_openFormulaEditor', 'ckeditor_wiris_openFormulaEditorChemistry'].includes(commandName) ) {
          setTimeout(() => {
              const wiris_license_overlays = document.querySelectorAll('.wrs_tickContainer')
              wiris_license_overlays.forEach(element => {
                element.remove();
              });
            }, 2000)
        }
      })
    }
  },
  validateEditor() {
    
    const strippedContent = this.comment.replace(/<[^>]*>/g, '').trim();
    const wordCount = strippedContent.split(/\s+/).length;
      
          if (!strippedContent) {
            this.editorError = 'Editor content cannot be empty';
            this.isEditorValid = false;
          } else if (wordCount < 10) {
            this.editorError = 'Content must be at least 10 words';
            this.isEditorValid = false;
          } else if (strippedContent.length > 1000) {
            this.editorError = 'Content is too long (maximum 1000 characters)';
            this.isEditorValid = false;
          } else {
            this.editorError = '';
            this.isEditorValid = true;
          }
          console.log('is editor valid', this.isEditorValid)
          return this.isEditorValid;
  },
}
</script>
<style scoped>
.view-more-link {
  font-size: 14px;
  color: #3F51B5;
  cursor: pointer;
}
.hide-element{
    visibility: hidden;
}
.row{
    flex: 0 0 auto;
}

.interviewer-name {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 10px;
    text-align: center;
}
.interviewer-header-cell {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 8px 4px;
}
.interviewer-email-label {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 13px;
    text-align: center;
    width: 100%;
    padding: 0 4px;
    cursor: default;
}
.interviewer-comments {
    width: 100%;
    max-width: none;
    min-width: 0;
    box-sizing: border-box;
    p {
        font-size: 14px;
    }
}
.vertical-menu{
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    overflow: hidden;
}
.mb-10px{
    margin-bottom:0px
}
.mx-h-81{
    max-height: 120px;
    /* display: flex;
    align-items: center */
}
.icon-aligner{
    margin-left: 90%; 
    margin-top: 2%;
}
.m-left-5{
   margin-right: 5px;
}
.m-left-10{
    margin-left: 10px;
}
.button-toggle-row{
  margin-top: 0px;  
}
.remark-color{
    max-height: 12vh;
    overflow: auto;
    color: #666666;
}
.first-row{
    margin-top: 0px;
}
.bottomDiv{
  margin: 10px 12px 4px 32px;

}
.data-grid {
    display: flex;
    flex-direction: column;   
    background-color: #FFFFFF;

}
.last-row {
  flex-grow: 1;
}
.recommend-txt{
    color:#4D695B;
    text-align: left;
}
.hold-txt{
    color:#B7842C;
    text-align: left;
}
.hold-bg{
    background-color: rgba(233, 182, 94, 0.24);
}
.recommend-bg{
    background-color: rgba(95, 159, 104, 0.24);
}
.rejected-bg {
    background-color: #F9DBE1;
}
.hold-txt {
    color: #FB7500;
}
.recommended-txt {
    color: #007C2A;
}
.rejected-txt {
    color: #D40028;
}
.feedback-title{
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    font-family: "GraphikMedium", sans-serif !important;
    span {
        font-weight: normal;
    }
    &.interview-average-ratings {
        padding: 10px 0;
        span {
            font-size: 14px;
            font-weight: 500;
        }
    }
}
.feedback-desc{
    font-size: 12px;
    color:rgba(0, 0, 0, 0.6);
    padding-left: 10px;
}
.interviewer-name, .recommend-txt, .hold-txt{
    font-size: 14px;
}
.average-text{
    display: flex;
    font-size: 14px;
}
.interview-remark{
    color: rgba(0, 0, 0, 0.6);
    text-align: left;
}
.col-text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}
.containerPsychrometricHard, .containerPsychrometricLite, .containerComputerHard, .containerComputerLite, .containerEnglishHard, .containerEnglishLite, .containerCoreSkillLite ,.containerCoreSkillHard,.containerPedagigyHard,  .containerPedagigyLite{
    height: 100px;
    padding: 5px;
}
.main-table{
    display: flex;
}
.central-table{
    display: flex;
    .data-grid.interview-report-data-grid {
        padding: 0 0 0 16px;
    }
}
.border-right {
    border-right: 1px solid #0000001F !important;
}

.score-container {
    background: #06C2702B;
    border: 1px solid #06C270;
    border-radius: 8px;
}

.w-90 {
    width: 90%
}

.col-2 {
    flex: 0 0 12.666667%;
    max-width: 12.6666666667%;
}
.scroll-this{
    display: flex;
    overflow: auto;
   height: calc(100vh - 243px);
   /* 100vh on mobile is measured with the browser chrome hidden, overestimating the
      real visible height and pushing content below this (e.g. Cancel/Proceed in the
      parent form) past the actual viewport. dvh tracks the real visible viewport. */
   height: calc(100dvh - 243px);
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.larger-bottom{
   
    position: relative;    
    
}
.read-larger-bottom{    
}
.write-larger-bottom{
    width: 100%;
}
.larger-bottom::-webkit-scrollbar {
    display: none;
}

.m-width-none {
    max-width: none;
}
.skill-btn {
    white-space: nowrap; 
    text-align: center;
}

.interview-details-main-container {
    width: auto;
    background: var(--white);
    .central-table, .main-table, .data-grid {
        width: 100%;
    }
    .mx-h-81 {
        max-height: 100%;
    }
    .v-tab {
        flex: 1;
    }
}

.interview-report-main-container {
    width: 100%;
    background: var(--white);
    margin: 0;
    border-radius: 8px;
    overflow: hidden;
    .data-grid {
        width: 100%;
        padding: 0 16px;
    }
    .central-table, .main-table {
        width: 100%;
    }
    .mx-h-81 {
        max-height: 100%;
    }
    .data-grid.interview-report-data-grid {
        padding: 0 16px;   
    }
    .central-table {
        margin-top: 10px;
    }
}
.interview-report-main-container {
    /* padding-bottom: 30px; */
    .comment-section {
        padding: 0 16px;
        background: var(--gray-06);
    }
}
.interview-ratings, .interview-average-ratings {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex: 1 1 0;
    min-width: 0;
}
.interview-average-ratings {
    align-items: center;
}
.assessment-instructions {
    padding-right: 50px;
}
/* The Average + Comments rows share one grey footer band, set off from the white score table.
   Left padding matches the score grid (16px) and right padding is 0 so columns stay aligned. */
.comment-section {
    background: var(--gray-06);
    padding: 12px 0 16px 16px;
}
.comment-container {
    padding: 12px 0;
}
.comment-container > .flex-1,
.comment-container > .d-flex.flex-1 {
    flex: 1 1 0;
    min-width: 0;
}
.interviewer-bg {
    background: linear-gradient(0deg, rgba(233, 182, 94, 0.24) 0%, rgba(233, 182, 94, 0.24) 100%), #FFF;
}
.interview-details-main-container {
    &.interview-report-main-container {
        width: auto;
    }
}
.m-ckeditor {
  height: 160px;
}
.v-sheet.v-card:not(.v-sheet--outlined){
    box-shadow: none;
}

/* ===== Two-pane report: fixed 50% labels + 50% horizontally scrolling columns ===== */
.report-scroll-shell {
    position: relative;
}
/* Left pane: Parameters / Average / Comments labels, fixed at half the row. */
.report-row-label {
    flex: 0 0 50%;
    width: 50%;
    max-width: 50%;
    min-width: 50%;
}
/* Right pane: interviewer columns scroll within their own half, never under the labels. */
.columns-scroll {
    flex: 0 0 50%;
    max-width: 50%;
    overflow-x: auto;
    overflow-y: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
}
.columns-scroll::-webkit-scrollbar {
    display: none;
}
.columns-scroll .report-col-cell {
    flex: 0 0 var(--interviewer-col-width, 132px);
    min-width: var(--interviewer-col-width, 132px);
}
.columns-scroll .report-col-cell:first-child {
    margin-left: auto;
}
.comment-section .report-row-label {
    flex: 1 1 auto;
    max-width: none;
    min-width: 0;
}
.comment-section .columns-scroll {
    flex: 0 0 auto;
    width: max-content;
    max-width: 50%;
}
.report-arrow {
    position: absolute;
    transform: translateY(-50%);
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    z-index: 5;
    background: var(--white) !important;
    color: var(--blue-01) !important;
    border: 1px solid rgba(63, 81, 181, 0.12);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.18) !important;
}
.report-arrow.v-btn--disabled {
    background: var(--white) !important;
    color: rgba(0, 0, 0, 0.26) !important;
    opacity: 1;
}
.report-arrow .v-icon {
    font-size: 20px;
}
.report-arrow--left {
    left: 50%;
    transform: translate(-50%, -50%);
}
.report-arrow--right {
    right: 0;
}
</style>
